export default "/images/vendor/flag-icon-css/flags/4x3/es.svg?36cdd00d34fa3ab9d98aba66d3ac5b39";